import m from "mithril";
import _ from "underscore";
import {XmlTagInfo} from '../../model/xmlTagProvider'
import {CellItem} from '../../model/items/cellItem'

export function hideSwitch (tags: XmlTagInfo[]){
	var image = _(tags).findWhere({tag: 'image'});
	return image && image.attributes && image.attributes['selected'];
}

export function missingView () {
	return m('.error', 'There is no view defined.');
}

export function simpleContent(controller:any, tags: XmlTagInfo[], selected?: any ){
	return _(tags).map(t => {
		if(t.tag === 'image'){
			let src = selected ? t.attributes['selected'] : null;
			src = src || t.attributes['normal'] || t.attributes['url'];
			const hover = t.attributes['hover'];
			if( hover ) {
                return m('span.image', {
                        'class': (selected ? 'selected' : 'unselected')
                    }, [
                        m('img.normal', { src: controller.questionary.getFileUrl(src)}),
                        m('img.hover', { src: controller.questionary.getFileUrl(hover)})
                    ]
                );
			} else {
				return m('img', { src: controller.questionary.getFileUrl(src)});
			}
		}
		if(t.tag === 'text'){
			return m.trust(controller.questionary.renderText(t.value || ""));
		}
		return null;
	});
}

export function elementId(item: CellItem, id: string) {
	return "Q" + item.form.id + "_" + id;
}

export function classList(classes: string[]|{[key:string]:any}) {
	if (Array.isArray(classes)) {
		return classes.filter(item => !!item).join(' ');
	}
	// Assume Object
	return Object.keys(classes).filter(key => !!classes[key]).join(' ');
}
